<template>
  <div class="invoice-view">
    <!-- 顶部栏 -->
    <div class="view-header">
      <span class="back-btn" @click="handleBack"><i class="el-icon-arrow-left"></i></span>
      <span class="header-title">{{ $t('rosRecharge.viewInvoice') }}</span>
    </div>
    <!-- 内容区 -->
    <div class="view-body">
      <div class="view-content">
        <!-- 状态图标 + 文字（同一行） -->
        <div class="status-section">
          <div class="status-line">
            <!-- <i v-if="status === 'success'" class="el-icon-success status-icon status-success"></i>
            <i v-else-if="status === 'pending'" class="el-icon-loading status-icon status-pending"></i>
            <i v-else class="el-icon-error status-icon status-fail"></i> -->
            <img v-if="status === 'success'" src="@/assets/img/recharge/billingok.png" class="status-icon" alt="">
            <img v-else-if="status === 'pending'" src="@/assets/img/recharge/billingwait.png" class="status-icon" alt="">
            <img v-else  src="@/assets/img/recharge/billingerr.png" class="status-icon" alt="">
            <span class="status-title" :class="'status-title-' + status">{{ statusTitle }}</span>
          </div>
          <div class="status-desc">{{ statusDesc }}</div>
        </div>
        <!-- 发票图片预览区 -->
        <div class="invoice-preview">
          <embed v-if="status === 'success' && invoiceResult && invoiceResult.invoiceUrl" :src="invoiceResult.invoiceUrl + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH'" type="application/pdf" class="invoice-pdf" />
          <img v-else-if="status === 'pending'" src="@/assets/img/recharge/bilWat.png" class="invoice-img invoice-default" :alt="$t('rosRecharge.invoicing')" />
          <img v-else src="@/assets/img/recharge/bilErr.png" class="invoice-img invoice-default" :alt="$t('rosRecharge.invoiceFailed')" />
        </div>
        <!-- 底部按钮 -->
        <div class="bottom-action" v-if="status === 'success'">
          <button class="btn btn-action" @click="handleDownload">{{ $t('rosRecharge.downloadPdf') }}</button>
        </div>
        <div class="bottom-action" v-else-if="status === 'fail'">
          <button class="btn btn-action" @click="handleContact">{{ $t('rosRecharge.manualService') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'invoiceView',
  props: {
    invoiceResult: {
      type: Object,
      default: () => ({})
    },
    // 'success' | 'pending' | 'fail'
    status: {
      type: String,
      default: 'pending'
    }
  },
  computed: {
    statusTitle() {
      const map = {
        success: this.$t('rosRecharge.invoiceSuccess'),
        pending: this.$t('rosRecharge.invoicing') + '...',
        fail: this.$t('rosRecharge.invoiceFailed')
      };
      return map[this.status] || this.$t('rosRecharge.invoicing') + '...';
    },
    statusDesc() {
      const map = {
        success: this.$t('rosRecharge.invoiceSentToEmail'),
        pending: this.$t('rosRecharge.pleaseWaitInvoicing'),
        fail: this.$t('rosRecharge.pleaseContactManual')
      };
      return map[this.status] || '';
    }
  },
  methods: {
    handleBack() {
      this.$emit('back');
    },
    handleDownload() {
      if (this.invoiceResult && this.invoiceResult.invoiceUrl) {
        window.open(this.invoiceResult.invoiceUrl);
      } else {
        this.$message.warning(this.$t('rosRecharge.noPdfAvailable'));
      }
    },
    handleContact() {
      if (window._MEIQIA) {
        window._MEIQIA('showPanel');
      } else {
        this.$message.warning(this.$t('rosRecharge.serviceUnavailable'));
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.invoice-view {
  display: flex;
  flex: 1;
  flex-direction: column;
  background: rgb(34, 45, 53);
  overflow: auto;

  .view-header {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 16px;
    background: rgb(34, 45, 53);
    border-bottom: 1px solid rgba(198, 209, 221, 0.2);

    .back-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      cursor: pointer;
      color: #ffffff;
      font-size: 18px;

      &:hover {
        color: @primaryTextColor;
      }
    }

    .header-title {
      font-size: 16px;
      color: #ffffff;
      margin-left: 8px;
    }
  }

  .view-body {
    flex: 1;
    overflow-y: auto;
    padding: 24px 0;

    .view-content {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .status-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;

    .status-line {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .status-icon {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }

      .status-success {
        color: @primaryTextColor;
      }

      .status-pending {
        color: #409EFF;
      }

      .status-fail {
        color: #F56C6C;
      }

      .status-title {
        font-size: 18px;
        font-weight: 500;
      }

      .status-title-success {
        color: @primaryTextColor;
      }

      .status-title-pending {
        color: #409EFF;
      }

      .status-title-fail {
        color: #F56C6C;
      }
    }

    .status-desc {
      font-size: 13px;
      color: #7b8395;
    }
  }

  .invoice-preview {
    width: 100%;
    max-width: 600px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    .invoice-img {
      width: 100%;
      display: block;
    }

    .invoice-pdf {
      width: 100%;
      height: 400px;
      border: none;
      border-radius: 4px;
      background: #ffffff;
      display: block;
    }

    .invoice-placeholder {
      color: #999;
      font-size: 14px;
    }
  }

  .bottom-action {
    display: flex;
    justify-content: center;

    .btn-action {
      min-width: 120px;
      height: 36px;
      line-height: 36px;
      padding: 0 24px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      // border: 1px solid @primaryTextColor;
      background: @primaryTextColor;
      color: #000;
      border: none;
      transition: all 0.2s;

      &:hover {
        opacity: 0.85;
      }
    }
  }
}
</style>
